import { useMutation } from '@tanstack/react-query';

import get from 'lodash/get';

import {
  AccountApiAccountValidateUsernameGetRequest,
  Api,
  useApi,
} from '@sbv-clients/data-access-api';
import { useSnackBar } from '@sbv-clients/ui-shared';

const validateUsername =
  (api: Api) =>
  ({ username }: AccountApiAccountValidateUsernameGetRequest) => {
    return api.accountApi.accountValidateUsernameGet({ username });
  };

export const useValidateUsername = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(validateUsername(api), {
    onError: async (error) => {
      const message =
        get(error, 'response.data.message', '') || get(error, 'message', '');
      notifyError(message);
    },
  });
};
